import { Link } from "react-router-dom";
import Seo from "../components/Seo";

export default function NotFound() {
    return (
        <main data-testid="page-404" className="pt-40 pb-32 px-6 md:px-12 lg:px-24 min-h-[60vh]">
            <Seo path="/404" title="Page not found" noindex />
            <p className="asc-overline">Error 404</p>
            <h1 className="serif text-5xl lg:text-7xl mt-6 leading-[1.02] tracking-tight font-light">
                This page is <span className="italic">unfurnished.</span>
            </h1>
            <p className="mt-8 max-w-xl text-lg text-[#5C5855]">
                The page you are looking for has been moved or never existed.
            </p>
            <Link to="/" data-testid="back-home" className="inline-flex mt-10 px-8 py-4 bg-[#1A1A1A] text-[#F9F8F6] text-[11px] uppercase tracking-[0.24em] hover:bg-[#3E3A37]">
                Return home
            </Link>
        </main>
    );
}
